import React from 'react';

export interface DashboardTierProps {
  label: string;
  ariaLabel?: string;
  children: React.ReactNode;
  className?: string;
}

const DashboardTier: React.FC<DashboardTierProps> = ({
  label,
  ariaLabel,
  children,
  className = '',
}) => (
  <section
    aria-label={ariaLabel ?? label}
    className={`space-y-4 ${className}`.trim()}
  >
    <h2 className="text-sm font-semibold text-fg-muted uppercase tracking-wide">
      {label}
    </h2>
    <div className="space-y-4">{children}</div>
  </section>
);

export default DashboardTier;
